import React from "react";
import { Loader, Skeleton } from "@progress/kendo-react-indicators";

// Loader Overlay
const LoaderOverlay = ({ taskKey }) => {
  return (
    <div>
      {
        <div className='skeleton-editor' style={taskKey === "descriptionPopUp" ? { height: "550px" } : {}}>
          <div className='skeleton-toolbar'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton key={index} shape='rectangle' className='skeleton-toolbar-btn' style={{ width: "40px", height: "30px" }} />
            ))}
          </div>
          <div className='skeleton-content'>
            {Array.from({ length: 8 }).map((_, index) => (
              <Skeleton key={index} shape='rectangle' className='skeleton-content-line' style={{ width: `${40 + index * 5}%`, height: "15px" }} />
            ))}
          </div>
        </div>
      }
    </div>
  );
};

export default LoaderOverlay;
